function setCookie(key, value, expiry = 30) {
  var expires = new Date()
  expires.setTime(expires.getTime() + expiry * 24 * 60 * 60 * 1000)
  // document.cookie = `${key}=${value};expires=${expires.toUTCString()};SameSite=None;secure;path=/;`;
  document.cookie = `${key}=${value};expires=${expires.toUTCString()};path=/;`
}

function getCookie(key) {
  var value = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)')
  if (value) {
    if (value[2][0] == '{' || value[2][0] == '[') {
      value[2] = JSON.parse(value[2])
    }
    return value[2]
  }
}

function eraseCookie(key) {
  let value = JSON.stringify(getCookie(key))
  setCookie(key, value, -1)
}

// get session OR local storage
function getStorage(key, type = 'session') {
  var value = ''
  switch (type) {
    case 'session':
      value = sessionStorage.getItem(key)
      break
    case 'local':
      value = localStorage.getItem(key)
      break
  }
  if (value) {
    if (value[0] == '{' || value[0] == '[') value = JSON.parse(value)
  }

  return value
}

// set session OR local storage
function setStorage(key, value, type = 'session') {
  if (typeof value === 'object') value = JSON.stringify(value)
  switch (type) {
    case 'session':
      sessionStorage.setItem(key, value)

      break
    case 'local':
      localStorage.setItem(key, value)
      break
  }
  return value
}

function getQueryParams() {
  return new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  })
}

function isPrivateIP(ip) {
  var parts = ip.split('.')
  return (
    parts[0] === '10' ||
    (parts[0] === '172' &&
      parseInt(parts[1], 10) >= 16 &&
      parseInt(parts[1], 10) <= 31) ||
    (parts[0] === '192' && parts[1] === '168') ||
    (parts[0] === '127' && parts[1] === '0' && parts[2] === '0')
  )
}

function parseJwt(token = getStorage('ss_token', 'local')) {
  var base64Url = token.split('.')[1]
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  var jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join('')
  )

  return JSON.parse(jsonPayload)
}

// standardized API request
function apiRequest(
  uri = '',
  method = 'GET',
  _data = [],
  dataType = 'JSON',
  async = true
) {
  if (uri == '') return false
  // if (window.location.host.split(":")[0] == "127.0.0.1" || window.location.host == "dev-whois.sipstack.com") {
  // 	uri = `${uri.split("?")[0]}.json`; // debug
  // }
  var url_base = `https://api.sipstack.com`
  // url_base = `http://192.168.1.30:3001`;
  return $.ajax({
    url: `${url_base}/v1/${uri}`,
    type: method,
    data: _data,
    dataType,
    async,
    crossDomain: true,
    xhrFields: {
      withCredentials: true,
    },
    headers: {
      // Authorization: "Bearer " + window.sessionStorage.getItem("ss_token"),
      // "X-HTTP-Method-Override": method.toUpperCase(),
      // "X-TA-SESSION": localStorage.session_id,
      // "X-TA-ACCOUNT": localStorage.account_id,
      // "X-TA-C": localStorage.c_id,
      // "X-TA-META": localStorage.meta,
    },
  })
}

// console.log('test')

// cookie

function fn_cookie() {
  if (!getCookie('ss_cookie')) {
    var url = window.location.pathname
    if (url != '/legal/cookie/') {
      $('#ss-cookie').toggleClass('show')
    }
  }

  $('#ss-cookie-accept').on('click', () => {
    setCookie('ss_cookie', Date.now(), '180')
  })
}

function form_autocomplete(inp, arr) {
  /*the autocomplete function takes two arguments,
  the text field element and an array of possible autocompleted values:*/
  var currentFocus
  /*execute a function when someone writes in the text field:*/
  inp.addEventListener('input', function (e) {
    var a,
      b,
      i,
      val = this.value
    /*close any already open lists of autocompleted values*/
    closeAllLists()
    if (!val) {
      return false
    }
    currentFocus = -1
    /*create a DIV element that will contain the items (values):*/
    a = document.createElement('DIV')
    a.setAttribute('id', this.id + 'autocomplete-list')
    a.setAttribute('class', 'autocomplete-items')
    /*append the DIV element as a child of the autocomplete container:*/
    this.parentNode.appendChild(a)
    /*for each item in the array...*/
    for (i = 0; i < arr.length; i++) {
      /*check if the item starts with the same letters as the text field value:*/
      if (arr[i].substr(0, val.length).toUpperCase() == val.toUpperCase()) {
        /*create a DIV element for each matching element:*/
        b = document.createElement('DIV')
        /*make the matching letters bold:*/
        b.innerHTML = '<strong>' + arr[i].substr(0, val.length) + '</strong>'
        b.innerHTML += arr[i].substr(val.length)
        /*insert a input field that will hold the current array item's value:*/
        b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>"
        /*execute a function when someone clicks on the item value (DIV element):*/
        b.addEventListener('click', function (e) {
          /*insert the value for the autocomplete text field:*/
          inp.value = this.getElementsByTagName('input')[0].value
          /*close the list of autocompleted values,
              (or any other open lists of autocompleted values:*/
          closeAllLists()
        })
        a.appendChild(b)
      }
    }
  })
  /*execute a function presses a key on the keyboard:*/
  inp.addEventListener('keydown', function (e) {
    var x = document.getElementById(this.id + 'autocomplete-list')
    if (x) x = x.getElementsByTagName('div')
    if (e.keyCode == 40) {
      /*If the arrow DOWN key is pressed,
        increase the currentFocus variable:*/
      currentFocus++
      /*and and make the current item more visible:*/
      addActive(x)
    } else if (e.keyCode == 38) {
      //up
      /*If the arrow UP key is pressed,
        decrease the currentFocus variable:*/
      currentFocus--
      /*and and make the current item more visible:*/
      addActive(x)
    } else if (e.keyCode == 13) {
      /*If the ENTER key is pressed, prevent the form from being submitted,*/
      e.preventDefault()
      if (currentFocus > -1) {
        /*and simulate a click on the "active" item:*/
        if (x) x[currentFocus].click()
      }
    }
  })
  function addActive(x) {
    /*a function to classify an item as "active":*/
    if (!x) return false
    /*start by removing the "active" class on all items:*/
    removeActive(x)
    if (currentFocus >= x.length) currentFocus = 0
    if (currentFocus < 0) currentFocus = x.length - 1
    /*add class "autocomplete-active":*/
    x[currentFocus].classList.add('autocomplete-active')
  }
  function removeActive(x) {
    /*a function to remove the "active" class from all autocomplete items:*/
    for (var i = 0; i < x.length; i++) {
      x[i].classList.remove('autocomplete-active')
    }
  }
  function closeAllLists(elmnt) {
    /*close all autocomplete lists in the document,
    except the one passed as an argument:*/
    var x = document.getElementsByClassName('autocomplete-items')
    for (var i = 0; i < x.length; i++) {
      if (elmnt != x[i] && elmnt != inp) {
        x[i].parentNode.removeChild(x[i])
      }
    }
  }
  /*execute a function when someone clicks in the document:*/
  document.addEventListener('click', function (e) {
    closeAllLists(e.target)
  })
}
